import {Injectable} from '@angular/core';
import {RequesterService} from "../shared/services/requester/requester.service";
import {DbStoreState} from '../store/reducers';
import {Store} from '@ngrx/store';
import * as fromStore from '../store';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import {combineLatest, Observable} from "rxjs";


@Injectable()
export class OutlineHandlerService {

  private _ownerWorkspaceId: number;
  private _currentWorkspaceId: number;
  private authorizationKey = 'MdRze9DcdD2iwe';

  constructor(private _requester: RequesterService,
              private _httpClient: HttpClient,
              private _store: Store<DbStoreState>) {
    this._getWorkspaceEntities();
  }

  generateOutline(data, testMode: boolean): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization-key': this.authorizationKey,
    });
    const url = `https://testai20.10web.io/api/${testMode ? 'test' : 'ai'}/outline_styles`;

    return this._httpClient.post(url, data, {headers});
  }

  saveOutline(data, testMode: boolean) {
    const headers = new HttpHeaders({
      'Authorization-key': this.authorizationKey,
    });
    const url = `https://testai20.10web.io/api/ai/template_from_outline`;
    return this._httpClient.post(url, data, {headers});
  }

  sendUrl(url: string, domain_id: number) {
    return this._requester.manager
      .post(`workspaces/${this._currentWorkspaceId}/domains/${domain_id}/templates/create-from-url-v2`, null, {url});
  }

  private _getWorkspaceEntities(): void {
    combineLatest(
      this._store.select(fromStore.getUserSubscription),
      this._store.select(fromStore.getWorkspaceIdEntities)
    ).subscribe(([userSubscription, workspaceIdEntities]) => {
      this._ownerWorkspaceId = workspaceIdEntities.ownerWorkspaceId;
      this._currentWorkspaceId = workspaceIdEntities.currentWorkspaceId || this._ownerWorkspaceId;
    });
  }

}
